<template lang="html">
  <div
    class="icon-tile"
  >
    <div
      :style="{ backgroundColor: item.columns.background }"
      :class="[ `icon-tile__card--theme-${item.columns.color}` ]"
      class="icon-tile__card"
    >
      <Headline
        v-if="item.columns.title"
        :size="1"
        :color="item.columns.color === 'light' ? 'white' : 'black'"
        center
      >
        <span
          v-html="item.columns.title"
        />
      </Headline>
      <Media
        v-if="item.columns.media"
        :path="item.columns.media.path"
        class="icon-tile__icon"
      />
      <Paragraph
        v-if="item.columns.text"
        class="icon-tile__text"
      >
        <span
          v-html="item.columns.text"
        />
      </Paragraph>
    </div>
  </div>
</template>

<script>
import Headline from 'beisheim/components/elements/headline'
import Paragraph from 'beisheim/components/elements/paragraph'
import Media from 'beisheim/components/elements/media'

export default {
  components: {
    Media,
    Headline,
    Paragraph
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/scale';
@import '~beisheim/scss/breakpoints';
@import '~beisheim/scss/px-to-rem';

.icon-tile {
  display: flex;
  height: auto;
  width: 100%;
  border-radius: 30px;
  overflow: hidden;

  &__text {
    max-width: px-to-rem(400px);
    margin-left: auto;
    margin-right: auto;
  }

  &__card {
    padding: scale(6);
    position: relative;
    text-align: center;
    width: 100%;

    @include from(6) {
      padding: scale(12);
    }

    &:before {
      position: absolute;
      top: scale(6);
      left: scale(6);
    }

    &--theme-dark {
      color: #333;
    }
    &--theme-light {
      color: #fff;
    }
  }

  &__icon {
    display: block;
    margin: scale(5) auto scale(6);
    width: scale(22);
    height: scale(22);
  }
}
</style>
